'use client';
import React from 'react';
import Link, { LinkProps } from 'next/link';
import { Link as LinkType } from '@workspace/interfaces';
import type { UrlObject } from 'url';
import { getLinkProps } from '@workspace/lib';
type Url = string | UrlObject;

type LinkWrapperProps = {
  link?: LinkType | string | null;
  children: React.ReactNode;
  className?: string;
  /**
   * @deprecated Use 'link' prop instead.
   */
  href?: Url;
} & Omit<LinkProps, 'href'>;

/**
 * A reusable component that wraps content with appropriate link behavior
 * based on the Link type (internal, external, or anchor).
 * Uses getLinkProps for unified link handling logic.
 * @example
 * <LinkWrapper link="/about">About Us</LinkWrapper>
 */
export function LinkWrapper({ link, children, className, ...props }: LinkWrapperProps) {
  // If no link is provided, render children without wrapper
  if (!link) {
    return <>{children}</>;
  }

  const linkProps = getLinkProps(link);

  // If getLinkProps returns empty object, render children without wrapper
  if (!linkProps.href) {
    return <>{children}</>;
  }

  return (
    <Link {...linkProps} className={className} prefetch={true} {...props}>
      {children}
    </Link>
  );
}
